<!--
 * @Descripttion: 
 * @version: 0.1
 * @Author: lixianbing
 * @Date: 
 * @LastEditors: wanglong
 * @LastEditTime: 2021-07-28 14:49:58
 -->
<template>
  <div class="home">
    <!-- 顶部模块 -->
    <div class="box">
      <ul class="list">
        <li>
          <div class="left">用户名</div>
          <div class="right">{{ username }}</div>
        </li>
        <li>
          <div class="left">联系人</div>
          <div class="right">{{ contacts }}</div>
        </li>
        <li>
          <div class="left">联系人手机号</div>
          <div class="right">{{ contactsTel }}</div>
        </li>
        <li>
          <div class="left">合唱团名称</div>
          <div class="right">{{ teamChorusCh }}</div>
        </li>
        <li>
          <div class="left">邮箱</div>
          <div class="right">{{ email }}</div>
        </li>
        <li>
          <div class="left">报名活动</div>
          <div class="right">{{ activityName }}</div>
        </li>
        <li>
          <div class="left">报名时间</div>
          <div class="right">{{ createdTime }}</div>
        </li>
        <li>
          <div class="left">审核状态</div>
          <div class="right">
            <span v-if="state == 0">待提交</span>
              <span v-if="state == 1">报名待审核</span>
              <span v-if="state == 2">报名审核通过</span>
              <span v-if="state == 3">缴费待审核</span>
              <span v-if="state == 4">缴费审核已通过</span>
              <span v-if="state == 5">缴费审核未通过</span>
              <span v-if="state == 6">报名审核未通过</span>
              <span v-if="state == 7">已退赛</span>
               <span v-if="state == 8">报名成功</span>
          </div>
        </li>
         <li>
          <div class="left">备注</div>
          <div class="right">{{ auditReason }}</div>
        </li>
      </ul>
      <div class="base">
        <ul>
          <li>你可以通过以下方式联系我们：</li>
          <li>
            <span>INTERKULTUR国际文化交流基金会（德国）亚洲中国事务部北方代表处</span></br>
            <span>电话： 010-63968766</span></br>
            <span>微信号/QQ：2318551129</span></br>
            <span>电子邮箱：zhangxiaoyan@interkultur.com.cn</span>
          </li>
          <li>
             <span>INTERKULTUR国际文化交流基金会（德国）亚洲中国事务部南方代表处</span></br>
            <span>电话： 020-83635878 </span></br>
            <span>微信号/QQ：634831329</span></br>
            <span>电子邮箱： hoju@interkultur.com.cn</span>
           
          </li>
          <!-- <li style="padding-left: 32px">
            INTERKULTUR国际文化交流基金会（德国）总部&nbsp;&nbsp;&nbsp;地址：INTERKULTUR
            Ruhberg 1, 35463 Fernwald, Germany&nbsp;&nbsp;&nbsp;电话: +49
            (0)6404 69749-25 &nbsp;&nbsp;&nbsp;传真: +49 (0)6404 69749-29
            &nbsp;&nbsp;&nbsp;电邮： mail@interkultur.com&nbsp;&nbsp;&nbsp;网页:
            www.interkultur.com
          </li> -->
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { apply_detail, applysubmit } from "@/api/file"; // 接口导入
export default {
  components: {},
  computed: {},
  data() {
    return {
      username: "",
      contacts: "",
      contactsTel: "",
      teamChorusCh: "",
      email: "",
      activityName: "",
      createdTime: "",
      auditReason: "",
      state: "", // 0.待提交，1.报名待审核 2.报名审核通过 3.缴费待审核 4.缴费审核已通过 5.报名审核未通过 6.缴费审核未通过
    };
  },

  created() {},
  mounted() {
    this.getdeils();
    localStorage.setItem("states", 1);
  },
  methods: {
    //查询用户已报名详情
    getdeils() {
      let data = {
        applyId: localStorage.getItem("id"),
      };
      apply_detail(data).then((res) => {
        this.username = res.data.username;
        this.contacts = res.data.contacts;
        this.contactsTel = res.data.contactsTel;
        this.state = res.data.state;
        this.activityName = res.data.activityName;
        this.createdTime = res.data.createdTime;
        this.teamChorusCh = res.data.teamChorusCh;
        this.email = res.data.teamEmailCh;
        this.auditReason = res.data.auditReason;
      });
    },
  },
};
</script>

<style scoped="" lang="scss">
.home {
  background: white;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 6px 0px rgba(43, 43, 43, 0.05);
  border-radius: 6px;
  height: 100%;
  display: flex;
  flex-direction: column;
  .box {
    margin: auto;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    .list {
      width: 100%;
      flex: 1;

      li {
        height: 50px;
        border: 1px solid gainsboro;
        border-bottom: none;
        margin-left: 150px;
        margin-right: 150px;
        display: flex;
        &:last-of-type {
          border-bottom: 1px solid gainsboro;
        }
        .left {
          width: 40%;
          height: 50px;
          border-right: 1px solid gainsboro;
          text-align: center;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(68, 68, 68, 1);
          line-height: 50px;
        }
        .right {
          width: 60%;
          height: 50px;
          text-align: center;

          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(68, 68, 68, 1);
          line-height: 50px;
        }
      }
      li:nth-of-type(1) {
        margin-top: 40px;
      }
    }
    .base {
      padding: 30px 150px;
      font-size: 16px;
      ul {
        li {
          span {
            float: none;
          }
        }
      }
      li {
        color: rgba(252, 82, 76, 1);
        line-height: 34px;
        // &:nth-of-type(2) {
        //   padding-left: 32px;
        // }
        // &:nth-of-type(3) {
        //   padding-left: 32px;
        // }
      }
    }
  }
}
</style>


